import { AssertionDescriptorUsageTypesEnum } from '../../utilities/Constants';
import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { JurisdictionStrategyDetail } from '../strategy/JurisdictionStrategyDetail';
import { Loader } from '../../components/shared/Loader';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';
import { useZoneGetAssertionDescriptors } from '../../shared/react-query-hooks/useZoneGetAssertionDescriptors';

function JurisdictionStrategyDetailWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const assertionDescriptorLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Strategy
    );

    if (assertionDescriptorLookup.isLoading) {
        return <Loader />;
    }

    return (
        <>
            <DocumentTitle title="Jurisdiction Detail" />
            <JurisdictionStrategyDetail
                guid={guid}
                user={user}
                zoneContext={zoneContext}
                assertionDescriptors={assertionDescriptorLookup.data ?? []}
            />
        </>
    );
}

export default JurisdictionStrategyDetailWrapper;
